var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.dropdown = {
	init: function () {
		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('a.special+ul','#btns').on('click', function(e) {
			e.stopPropagation();
		});

		$('a.special', '#btns').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$body = $('body');

			if (!$this.hasClass('open')) {
				$this.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				site.dropdown.close();
			}

			$('body.dropdown-open').on('click', function () {
				site.dropdown.close();
			});
		});
	},

	setHeight:function() {
		var $dropdown = $('a.special+ul', '#btns');
		$($dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	close:function() {
		$('a.special','#btns').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

site.formbuilder = {
	init:function() {
		if (!$('body').hasClass('formbuilder')) return false;

		$('.moya_form', '#formbuilder').each(function() {
			var $this = $(this);
			if ($this.find('fieldset').length > 0) {
				$this.addClass('hasFieldset');
			}
		});
	}
};

site.footer = {
	init: function() {
		var $link = $('a', '.logo').clone();
		$link.find('svg').remove();
		$link.addClass('home');
		$link.prependTo($('.box.first', '#footerInfo'));
	}
};

site.frontpage = {
	init: function() {
		if($('.box_social_instagram .grams .gram').length > 1) {
			site.owl.init('.box_social_instagram .grams', {
				loop: true,
				nav: true,
				dots:true,
				margin:2,
				lazyLoad:true,
				navText:['<div class="arrow"><i aria-label="Previous" class="fa fa-arrow-left" /></div>','<div class="arrow"><i aria-label="Next" class="fa fa-arrow-right" /></div>'],
				items: 6,
				autoplay:true,
				autoplayTimeout:8000,
				autoplayHoverPause: true,
				smartSpeed: 1000, // duration of change of 1 slide
				responsive: {
					0: {
						items: 1
					},
					450: {
						items: 2
					},
					768: {
						items: 3
					},
					1100: {
						items: 4
					},
					1500: {
						items: 6
					}
				}
			});
		}
	}
};

site.imageMap = {
	init: function() {
		var isIE = site.imageMap.isIE();
		$('a', '#cameras').wrapInner('<span>').click(function(e) {
			e.preventDefault();
			var url = $(this).attr('href');
			var title = $(this).attr('title');
			var width = $(document).width() * .8;
			width = width < 1280 ? width : 1280;
			var height = width * 0.5625;

			if (isIE) {
				alert('Því miður er ekki mögulegt að birta straum úr vefmyndavélum í Internet Explorer. \n\n' +
					'Vinsamlega prófaðu aðra vafra, t.d. Google Chrome, Firefox eða Edge');
			}
			else {
				site.imageMap.popCenter(url, title, width, height);
			}
		});
	},

	popCenter: function(url, title, w, h) {
		var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
		var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		var left = ((width / 2) - (w / 2)) + dualScreenLeft;
		var top = ((height / 2) - (h / 2)) + dualScreenTop;
		var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

		// Puts focus on the newWindow
		if (window.focus) {
			newWindow.focus();
		}
	},

	isIE: function() {
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.megamenu.init();
	site.dropdown.init();
	site.formbuilder.init();
	site.footer.init();
	site.imageMap.init();
	site.frontpage.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
